import { getHttpClient } from '../services/http'
import { dataSources } from './data-sources'

function getEnvObject (data) {
  const env = {}
  Object.keys(data).forEach(key => {
    const envKey = key.substring(key.lastIndexOf('.') + 1)
    env[envKey] = data[key]
  })
  return env
}

function setProcessEnv (envObject) {
  Object.keys(envObject).forEach(key => {
    process.env[key] = envObject[key]
  })
  return envObject
}

export async function initEnvConfig () {
  if (typeof window === 'undefined') {
    return import('../env-config').then(env => getEnvObject(env.default))
  } else {
    const ds = dataSources()
    const inst = getHttpClient()
    return inst
      .get(ds.config)
      .then((response) => {
        return setProcessEnv(getEnvObject(response.data))
      })
  }
}
